import React, { useContext } from 'react';
import i18n from '~/i18n';
import { RightOutlined } from '@ant-design/icons';
import useOpenOrderInfoPanel from '../OrderInfoPanel';
import PageContext from '../../context';
import clsx from 'clsx';
import { ORDER_TYPE_TEXT } from '@restaurant/constants';
import { Order } from '@restaurant/api';
import { OrderType } from '@restaurant/types';
import { Col, Row } from 'antd';

const OrderInfo = ({ order, isPaid }: { order: Order; isPaid: boolean }) => {
  const { refresh } = useContext(PageContext);

  let customerName = order.customerName;
  if (order.tableNumber) {
    customerName = i18n.t('order_info_table_no', { no: order.tableNumber });
    if (order.customerName) {
      customerName += ` (${order.customerName})`;
    }
  }

  // Order info panel.
  const openOrderInfoPanel = useOpenOrderInfoPanel(refresh);
  const handleClickOrderInfo = () => {
    if (isPaid) return;
    openOrderInfoPanel(order);
  };
  const content = (() => {
    if (order.orderType === OrderType.Indent) {
      const { delivery } = order;
      const { date, time } = delivery?.deliveryDateTime ?? {};
      const { streetAddressLine1, streetAddressLine2 } =
        delivery?.deliveryAddress ?? {};

      const deliveryTimeStr = `${[date, time].filter(Boolean).join(' ')}`;
      const addressStr = [streetAddressLine1, streetAddressLine2]
        .filter(Boolean)
        .join(' ');
      const phoneNumberStr = delivery
        ? `${delivery?.mobileCountryCode} ${delivery?.mobileNumber}`
        : '';

      const nameStr = delivery
        ? `${delivery?.recipientName ?? '-'} | ${phoneNumberStr}`
        : '';

      return (
        <div className="flex-1">
          <Row>
            <Col span={6} md={4}>
              <b>{ORDER_TYPE_TEXT[order.orderType]}</b>
            </Col>
            <Col span={18} md={10}>
              <span className="mr-2">Contact:</span>
              <b>{nameStr}</b>
            </Col>
            <Col span={24} md={10}>
              <span className="mr-2">Waktu ambil:</span>
              <b>{deliveryTimeStr}</b>
            </Col>
          </Row>
          <div>
            <span className="mr-2">Alamat: </span>
            <b>{addressStr}</b>
          </div>
        </div>
      );
    }

    let customerName = order.customerName;
    if (order.tableNumber) {
      customerName = i18n.t('order_info_table_no', { no: order.tableNumber });
      if (order.customerName) {
        customerName += ` (${order.customerName})`;
      }
    }

    return (
      <div className="flex-1">
        {ORDER_TYPE_TEXT[order.orderType]} | {customerName}
      </div>
    );
  })();

  return (
    <div
      className={clsx(
        'relative flex justify-between items-center py-2 px-4 bg-white',
        isPaid ? 'cursor-not-allowed' : 'cursor-pointer'
      )}
      style={{ borderBottom: '1px solid #eee' }}
      onClick={handleClickOrderInfo}
    >
      {content}
      <RightOutlined />
    </div>
  );
};

export default OrderInfo;
